import React from "react";
import ServiceCoverflowCarousel from "./Servicecoverflowcarousel.jsx";
import laundry from "../assets/new_image/laundry.png";
import maidWithJadu from "../assets/new_image/maidWIthJadu.png";
import japa from "../assets/new_image/Japa.png";
import cook from "../assets/new_image/maid.png";
import allRounder from "../assets/new_image/AllRounder.png";
import babysitter from "../assets/new_image/babysitter.png";

const services = [
  { id: "laundry", name: "Laundry", image: laundry },
  { id: "maid", name: "Maid", image: maidWithJadu },
  { id: "japa", name: "Japa", image: japa },
  { id: "cook", name: "Cook", image: cook },
  { id: "AllRounder", name: "AllRounder", image: allRounder },
  { id: "babysitter", name: "Babysitter", image: babysitter },
];

export default function ServicesSectionExample() {
  return (
    <section>
      <h2 style={{ textAlign: "center" }}>Our Services</h2>
      <ServiceCoverflowCarousel
        services={services}
        autoPlay={true}
        interval={3000}
        onChange={(service, index) => {
          // e.g. sync with a router, analytics, etc.
          console.log("Active service:", service.name, index);
        }}
      />
    </section>
  );
}